import { VarianceCode } from '__generated__/globalTypes';
export const VARIANCE_LABELS: Record<VarianceCode, string> = {
  [VarianceCode.BALANCE_INCREASED]: 'Balance increased',
  [VarianceCode.BALANCE_EXCEEDS_ORIGINAL]: 'Balance > original',
  [VarianceCode.DPD_REVERSED]: 'DPD reversed',
  [VarianceCode.DPD_OUT_OF_RANGE]: 'DPD out of range',
};

interface VarianceCodeBadgeProps {
  code: VarianceCode;
  focused: boolean;
  acknowledged: boolean;
  disabled: boolean;
  onSelect: (code: VarianceCode) => void;
}

const VarianceCodeBadge = ({
  code,
  focused,
  acknowledged,
  disabled,
  onSelect,
}: VarianceCodeBadgeProps): JSX.Element => {
  const baseClass =
    'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pink-300';
  const stateClass = focused
    ? 'bg-pink-500/20 text-pink-300 ring-pink-400'
    : acknowledged
      ? 'bg-slate-500/20 text-slate-400 ring-slate-500/40'
      : 'bg-slate-500/20 text-slate-200 ring-slate-500/40 hover:bg-slate-500/30';
  const interactionClass =
    disabled && !focused ? 'cursor-not-allowed opacity-60' : 'cursor-pointer';
  return (
    <button
      type="button"
      data-testid={`variance-badge-${code}`}
      aria-pressed={focused}
      aria-label={`Switch to ${VARIANCE_LABELS[code]}`}
      title={disabled && !focused ? 'Save or cancel first' : VARIANCE_LABELS[code]}
      disabled={disabled && !focused}
      onClick={() => onSelect(code)}
      className={`${baseClass} ${stateClass} ${interactionClass}`}
    >
      {VARIANCE_LABELS[code]}
    </button>
  );
};

export default VarianceCodeBadge;
